import { QRCodeSVG } from "qrcode.react";
import { Smartphone } from "lucide-react";
import { isAndroid, isIOS } from "@/lib/push";

const URL_APP = `${window.location.origin}/app#installieren`;

export const isDesktop = () => !isIOS() && !isAndroid() && window.matchMedia("(min-width: 768px)").matches;

export function DesktopQr({ variant = "card" }) {
  if (!isDesktop()) return null;
  if (variant === "float") return (
    <div className="hidden lg:flex fixed bottom-6 left-6 z-40 items-center gap-3 rounded-3xl bg-white/95 backdrop-blur border border-pink-100 shadow-xl shadow-rose-200/50 p-3 pr-5 fade-up" data-testid="desktop-qr-float">
      <div className="p-1.5 rounded-2xl bg-white border border-pink-100"><QRCodeSVG value={URL_APP} size={84} fgColor="#E11D48" /></div>
      <div className="max-w-[150px]">
        <p className="text-sm font-extrabold leading-tight">Hol dir die App aufs Handy</p>
        <p className="text-xs text-slate-500 mt-1">Mit der Handy-Kamera scannen</p>
      </div>
    </div>
  );
  return (
    <div className="flex items-center gap-5 rounded-3xl bg-white border border-pink-100 p-5 shadow-lg shadow-rose-100" data-testid="desktop-qr-card">
      <div className="p-2 rounded-2xl bg-white border-2 border-rose-100 shrink-0"><QRCodeSVG value={URL_APP} size={132} fgColor="#E11D48" imageSettings={{ src: "/icon-192.png?v=4", height: 30, width: 30, excavate: true }} /></div>
      <div className="space-y-1.5">
        <p className="inline-flex items-center gap-1.5 text-xs font-extrabold uppercase tracking-[0.15em] text-rose-500"><Smartphone className="w-4 h-4" /> Am Computer?</p>
        <p className="font-display text-xl font-extrabold leading-tight">Scanne den Code mit deinem Handy</p>
        <p className="text-sm text-slate-500">Öffne die Kamera, richte sie auf den Code und tippe auf den Link – schon landest du direkt bei der Installation.</p>
      </div>
    </div>
  );
}
